import { Ref, Prop, Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { cart } from "@/theme/Cart";
import { debounce } from 'lodash';
import { formatMoney } from '@/utils/formatting';

@Component
export class ShippingMessage extends ThemeComponent {

    @Prop({ default: null }) product!: ShopifyProduct|null;
    @Prop() shippingThreshold!: number;

    private totalPrice!: number;
    private totalDifference!: number;

    async init() {
        this.$subscribe(cart.onChange, debounce(() => {
            this.cartUpdated();
        }, 300));
    }

    cartUpdated() {
        // If a product is passed in, the shipping message should
        // be in content to the product
        if (this.product) {
            this.totalPrice = cart.totalPrice + this.product.price;
            this.totalDifference = Math.abs(cart.totalPrice - this.shippingThreshold);

            if (cart.totalPrice > this.shippingThreshold) {
                // If the cart total is above the threshold, render eligble message
                this.renderEligibleMessage();
            } else if (cart.totalPrice < this.shippingThreshold && this.totalDifference < this.product.price) {
                // If the cart total is less than the threshold,
                // but the price of the product will deem eligble
                // render incentive message
                this.renderIncentiveMessage();
            } else {
                // If the cart total is less than the threshold,
                // but the price of the product is less than the
                // required difference, render standard message
                this.renderStandardMessage();
            }
        } else {
            // Otherwise, the message should be in context to the existing cart contents
            this.totalPrice = cart.totalPrice;
            this.totalDifference = Math.abs(cart.totalPrice - this.shippingThreshold);

            if (cart.totalPrice > this.shippingThreshold) {
                // If the cart total is above the threshold, render eligble message
                this.renderEligibleMessage();
            } else if (cart.totalPrice < this.shippingThreshold) {
                // If the cart total is less than the threshold,
                // but the price of the product will deem eligble
                // render incentive message
                this.renderAmountMessage();
            } else {
                // If the cart total is less than the threshold,
                // but the price of the product is less than the
                // required difference, render standard message
                this.renderStandardMessage();
            }
        }

    }

    renderStandardMessage() {
        const messageHTML = `
            <div>Spend over ${formatMoney(this.shippingThreshold) as string} and get free shipping.</div>
        `;

        this.innerHTML = messageHTML;
    }

    renderEligibleMessage() {
        const messageHTML = `
            <div>Hooray! You're eligible for free shipping.</div>
        `;

        this.innerHTML = messageHTML;
    }

    renderIncentiveMessage() {
        const messageHTML = `
            <div>
                You're ${formatMoney(this.totalDifference) as string} away from free shipping.
                Adding this product to cart will make you eligible for free shipping.
            </div>
        `;

        this.innerHTML = messageHTML;
    }

    renderAmountMessage() {
        const messageHTML = `
            <div>
                You're ${formatMoney(this.totalDifference) as string} away from free shipping.
            </div>
        `;

        this.innerHTML = messageHTML;
    }

    removeMessage() {
        this.innerHTML = '';
    }

}
